import { FlaskConical } from "lucide-react";

export const fmtMoney = (v, cur = "USD") =>
  v === null || v === undefined ? "Not set" : new Intl.NumberFormat("en-US", { style: "currency", currency: cur }).format(v);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");

export function Panel({ title, action, children, className = "", ...rest }) {
  return (
    <section className={`rounded-2xl border border-white/10 bg-[#15121b]/70 p-5 ${className}`} {...rest}>
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between gap-3">
          {title && <h2 className="text-sm font-bold uppercase tracking-wider text-[#c9a6ff]">{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Stat({ label, value, testid }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
      <p className="text-[0.65rem] uppercase tracking-wider text-[#a7a0af]">{label}</p>
      <p data-testid={testid} className="mt-1 text-xl font-extrabold">{value}</p>
    </div>
  );
}

const PILL = {
  active: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  invited: "border-[#6a00ff]/50 bg-[#6a00ff]/15 text-[#c9a6ff]",
  suspended: "border-red-400/40 bg-red-400/10 text-red-300",
  past_due: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  failed: "border-red-400/40 bg-red-400/10 text-red-300",
  succeeded: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  accepted: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  pending: "border-[#6a00ff]/50 bg-[#6a00ff]/15 text-[#c9a6ff]",
  expired: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  revoked: "border-red-400/40 bg-red-400/10 text-red-300",
  live: "border-[#d42be8]/60 bg-[#d42be8]/15 text-[#f0a8fa]",
  open: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  resolved: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
};

export function StatusPill({ status, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide ${PILL[status] || "border-white/15 bg-white/5 text-[#c7c1cf]"}`}>
      {String(status || "").replace(/_/g, " ")}
    </span>
  );
}

export function SandboxNotice({ className = "" }) {
  return (
    <div data-testid="sandbox-notice" className={`flex items-start gap-3 rounded-2xl border border-[#6a00ff]/40 bg-[#6a00ff]/10 p-3 ${className}`}>
      <FlaskConical size={16} className="mt-0.5 shrink-0 text-[#c9a6ff]" />
      <p className="text-xs leading-relaxed text-[#d8ccf0]">
        <span className="font-bold">PEEPING PAY · Sandbox mode.</span> No real processor is connected, no card data is collected and no money moves. Memberships activate only from verified, signed provider webhooks.
      </p>
    </div>
  );
}

export const inputCls = "field w-full rounded-xl px-3 py-2.5 text-sm";
